const defaultPublic = process.env.PUBLIC_URL;
export const LogoImageUrl = defaultPublic + '/wpcalendar.png';
export const chatImageUrl = defaultPublic + '/images/Chat.svg';
export const calendarImageUrl = defaultPublic + '/images/Calendar.svg';
export const privacyImageUrl = defaultPublic + '/images/Privacy.svg';
export const Error404ImageUrl = defaultPublic + '/images/404.svg';
export const videoThumbnailUrl = defaultPublic + '/images/VideoThumbnail.png';
export const seoThumbnailUrl = defaultPublic + '/SeoThumbnail.png';
